module.exports = "https://static.wmbcdn.com/uniweb/images/74170d7f57b229c5797bb36bdefdd170.svg";